import React from 'react';

export const FeedbackButtons = ({ feedback, feedbackLoading, onFeedback }) => {
  return (
    <div className="flex justify-center pt-6 mt-8 border-t-3 border-clay-border">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-secondary-text mr-2">Rate this summary:</span>

        {/* Thumbs Down */}
        <button
          onClick={() => onFeedback(-1)}
          disabled={feedbackLoading}
          className={`p-2.5 rounded-clay border-2 transition-all duration-200 ${
            feedback?.feedback_value === -1
              ? 'bg-rose-100 dark:bg-rose-900/40 border-fun-coral scale-110'
              : 'border-theme-border-subtle hover:border-fun-coral hover:bg-rose-50 dark:hover:bg-rose-900/30'
          } ${feedbackLoading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'}`}
          title="Poor quality"
        >
          {feedbackLoading && feedback?.feedback_value === -1 ? (
            <div className="spinner-fun-sm w-6 h-6"></div>
          ) : (
            <span className="text-2xl">👎</span>
          )}
        </button>

        {/* Neutral */}
        <button
          onClick={() => onFeedback(0)}
          disabled={feedbackLoading}
          className={`p-2.5 rounded-clay border-2 transition-all duration-200 ${
            feedback?.feedback_value === 0
              ? 'bg-amber-100 dark:bg-amber-900/40 border-fun-lemon scale-110'
              : 'border-theme-border-subtle hover:border-fun-lemon hover:bg-amber-50 dark:hover:bg-amber-900/30'
          } ${feedbackLoading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'}`}
          title="Alright"
        >
          {feedbackLoading && feedback?.feedback_value === 0 ? (
            <div className="spinner-fun-sm w-6 h-6"></div>
          ) : (
            <span className="text-2xl">😐</span>
          )}
        </button>

        {/* Thumbs Up */}
        <button
          onClick={() => onFeedback(1)}
          disabled={feedbackLoading}
          className={`p-2.5 rounded-clay border-2 transition-all duration-200 ${
            feedback?.feedback_value === 1
              ? 'bg-emerald-100 dark:bg-emerald-900/40 border-fun-mint scale-110'
              : 'border-theme-border-subtle hover:border-fun-mint hover:bg-emerald-50 dark:hover:bg-emerald-900/30'
          } ${feedbackLoading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'}`}
          title="Good quality"
        >
          {feedbackLoading && feedback?.feedback_value === 1 ? (
            <div className="spinner-fun-sm w-6 h-6"></div>
          ) : (
            <span className="text-2xl">👍</span>
          )}
        </button>
      </div>
    </div>
  );
};

export const MarkReadButton = ({ isRead, isUpdating, onMarkAsRead, onMarkAsReadStay }) => {
  if (isRead) {
    return (
      <div className="flex justify-center pt-8">
        <div className="inline-flex items-center px-4 py-2.5 bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-300
          rounded-clay border-2 border-fun-mint font-medium animate-pop">
          <span className="mr-2 text-lg" role="img" aria-hidden="true">✨</span>
          Article Read
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center gap-3 pt-8">
      {/* Done Reading - navigates away */}
      <button
        onClick={onMarkAsRead}
        disabled={isUpdating}
        className="btn-clay-accent inline-flex items-center group"
        title="Mark as read and return to dashboard"
      >
        {isUpdating ? (
          <>
            <div className="spinner-fun-sm w-4 h-4 mr-2"></div>
            Finishing...
          </>
        ) : (
          <>
            <span className="mr-2 text-lg group-hover:animate-bounce-gentle" role="img" aria-hidden="true">🎉</span>
            Done reading!
          </>
        )}
      </button>

      {/* Mark as Read - stays on page */}
      <button
        onClick={onMarkAsReadStay}
        disabled={isUpdating}
        className="btn-clay-ghost inline-flex items-center justify-center px-3"
        title="Mark as read (stay on page)"
      >
        {isUpdating ? (
          <div className="spinner-fun-sm w-4 h-4"></div>
        ) : (
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        )}
      </button>
    </div>
  );
};
